import { render, staticRenderFns } from "./AsignacionSitrackPantalla.vue?vue&type=template&id=e2efb262&"
import script from "./AsignacionSitrackPantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionSitrackPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports